import * as React from "react";
import Svg, { Line } from "react-native-svg";
const CrossDottedLine = (props) => (
  <Svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Line
      x1={1.43356}
      y1={48.8596}
      x2={49.5168}
      y2={0.776321}
      stroke="black"
      strokeOpacity={0.2}
      strokeDasharray="2 2"
    />
    <Line
      x1={1.14066}
      y1={0.776329}
      x2={49.2239}
      y2={48.8596}
      stroke="black"
      strokeOpacity={0.2}
      strokeDasharray="2 2"
    />
  </Svg>
);
export default CrossDottedLine;
